import Application from './apps/app';
import AppContentsLoader from './apps/system';
import SystemBase from './apps/system';
import { getLogger } from '@/engine/helper/Logger';

const configLogger = getLogger('config');

const Config: ConfigType = {
    appName: "MILC",
    domain: {
        site: "milc.watch.sharo-dev.com",
        account: "milc.sharo-dev.com",
        contents: "milc.sharo-dev.com",
        designing: "milc.sharo-dev.com",
    },
    endpoint: {
        key: "milc-dev",
        account: "https://milc.sharo-dev.com/account/",
        contents: "https://milc.sharo-dev.com/contents/",
        contentsWs: "https://milc.sharo-dev.com",
        designing: "https://milc.dev.sharo-dev.com/designing/",
        designingWs: "https://milc.dev.sharo-dev.com"
    },
    oauth2: {
        uuid: "fd9e01fb-9a8d-498f-bd5d-e5371058e751",
        accessToken: "evJe+uZ0megx6nUYX(Vzz0g:/&cR=H9-ekP0yZXettdL6cAe5JzXuif$z*%V7Rp8UX+kxCObII&U=_:Xf/uk+/3Pcn9dio)%SzXanslN-+9O40%MFJ;nWe!~^43oWjuO",
        secretToken: "dl2j+aQ~==(!Exdy!07%t%Om0ayWbx;I(Kxo-d|6MDB=(cjLvz!&-LoUEPy~3D)jBejYIB3PREJ:nN~s^52VFr3IxWfUDwiCBO/i8^on+Iah:yR:buSx-hX3prD_PZV+",
        redirect: "https://milc.watch.sharo-dev.com?app=account&callback=1",
    },
    debug: {
        sfu: true,
        layout: false,
        engine: false,
        ws: true,
        api: false,
        contents: false,
        "contents-datasource": false,
        "redirect-notification": true
    },
    application: {
        system: {
            launch: async () => (await import('@/apps/system/app')).default,
            system: async () => new (await import('@/apps/system/system')).default(),
        },
        startup: {
            launch: async () => (await import('@/apps/startup/app')).default,
        },
        manage: {
            launch: async () => (await import('@manage/app')).default,
            contents: async () => new (await import("@/apps/manage/contents")).default(),
            system: async () => new (await import('@/apps/manage/system')).default(),
        },
        account: {
            launch: async () => (await import('@account/app')).default,
            system: async () => new (await import('@account/system')).default(),
        },
        designing: {
            launch: async () => (await import('@/apps/designing/app')).default,
            system: async () => new (await import('@apps/designing/system')).default(),
        },
        carry: {
            launch: async () => (await import('@/apps/carry/app')).default,
            contents: async () => new (await import("@/apps/carry/contents")).default(),
            system: async () => new (await import('@/apps/carry/system')).default(),
        },
        carry2: {
            launch: async () => (await import('@/apps/carry2/app')).default,
            system: async () => new (await import('@/apps/carry2/system')).default(),
        },
        carry3: {
            launch: async () => (await import('@/apps/carry3/app')).default,
            system: async () => new (await import('@/apps/carry3/system')).default(),
        },
        creation: {
            launch: async () => (await import('@/apps/creation/app')).default,
            contents: async () => new (await import("@/apps/creation/contentsLoader")).default(),
            system: async () => new (await import('@/apps/creation/system')).default(),
        },
        external: {
            launch: async () => (await import('@/apps/external/app')).default,
            system: async () => new (await import('@/apps/external/system')).default(),
        },
        miniApp: {
            launch: async () => (await import('@/apps/external/mini-app/app')).default,
            contents: async () => new (await import("@/apps/external/mini-app/contents")).default(),
        },
        twitch: {
            launch: async () => (await import('@/apps/external/twitch/app')).default,
            system: async () => new (await import('@/apps/external/twitch/system')).default(),
        },
        valorant: {
            launch: async () => (await import('@/apps/external/valorant/app')).default,
            system: async () => new (await import('@/apps/external/valorant/system')).default(),
        },
        lol: {
            launch: async () => (await import('@/apps/external/lol/app')).default,
        },
        youtube: {
            launch: async () => (await import('@/apps/external/youtube/app')).default,
            system: async () => new (await import('@/apps/external/youtube/system')).default(),
        },
        apex: {
            launch: async () => (await import('@/apps/external/apex/app')).default,
            system: async () => new (await import('@/apps/external/apex/system')).default(),
        },
        sharo: {
            launch: async () => (await import('@/apps/sharo/app')).default,
            system: async () => new (await import('@/apps/sharo/system')).default(),
        },
        docs: {
            launch: async () => (await import('@/apps/docs/app')).default,
            system: async () => new (await import('@/apps/docs/system')).default(),
        }
    }
}

type ConfigType = {
    appName: string,
    domain: {
        site: string,
        account: string,
        contents: string,
        designing: string,
    },
    endpoint: {
        key: string,
        account: string,
        contents: string,
        contentsWs: string,
        designing: string,
        designingWs: string,
    },
    oauth2: {
        uuid: string,
        accessToken: string,
        secretToken: string,
        redirect: string,
    },
    startup?: {
        [key: string]: string
    }
    debug: { [key: string]: boolean },
    application: {
        [key: string]: {
            launch: () => Promise<typeof Application>,
            contents?: () => Promise<AppContentsLoader>,
            system?: () => Promise<SystemBase>,
            hide?: boolean,
        }
    }
}

var configInstance = Config;

export async function initializeConfig() {

    const manifest = await (await fetch("/manifest.json")).json();

    configInstance = deepAssign(configInstance, manifest);
    configLogger.info("Config updated");

    // Codex Added: 2025-10-21 manifest適用後にMILCのAPIを再構築
    try {
        const engine = await import("@/engine/milc");
        engine.milc.refreshDefaultApi();
        configLogger.info("MILC API refreshed by manifest");
    } catch (error) {
        configLogger.warn("Failed to refresh MILC API after manifest update", error as Error);
    }
}

function deepAssign(parent: any, child: any) {


    for (const key of Object.keys(child))
        if (typeof (child[key]) === "object") {
            if (typeof (child[key].length) === "number") {  // 子が配列の場合
                if (typeof (parent[key].length) === "number")   // 親も配列だった場合
                    parent[key] = [...(parent[key] as any[]), ...(child[key] as any[])];
                else                                            // 親はオブジェクトだった場合
                    parent[key] = child[key];
            }
            else {                                          // 子がオブジェクトの場合
                if (typeof (parent[key]) === "object")      // 親もオブジェクトだった場合
                    parent[key] = deepAssign(parent[key], child[key]);
                else                                        // 親は配列だった場合
                    parent[key] = child[key];
            }
        } else
            parent[key] = child[key];

    return parent;

}

export function getConfig() {
    return configInstance;
}
